import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "member-header widget"
}
const _hoisted_2 = { class: "member-header-avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "member-header-identity" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-grey-700 mb-0" }
const _hoisted_7 = { class: "member-header-collectivite" }
const _hoisted_8 = { class: "font-semibold mb-2" }
const _hoisted_9 = {
  class: "flex gap-2",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_10 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_11 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_12 = {
  key: 2,
  class: "tag-state notif stroke"
}
const _hoisted_13 = {
  key: 3,
  class: "tag-state danger stroke"
}
const _hoisted_14 = {
  key: 0,
  class: "member-header-date"
}
const _hoisted_15 = { class: "font-semibold text-xl" }
const _hoisted_16 = {
  key: 1,
  class: "member-header-progress"
}
const _hoisted_17 = { class: "progress-bar" }
const _hoisted_18 = { class: "progress-bar-label" }

import { computed } from 'vue';

interface Member {
    id: number;
    nom?: string;
    prenom?: string;
    reference?: string;
    photo_url?: string;
    email_verified_at?: string | null;
    actif?: number | boolean;
    collectivite?: { nom?: string } | null;
    [key: string]: any;
}

interface ProgressProps {
    label: string;
    percent: number;
    valueLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberInfoHeader',
  props: {
    member: {},
    title: {},
    endDate: {},
    progress: {}
  },
  setup(__props: any) {

const props = __props;

const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const endDateFormatted = computed(() => {
    if (!props.endDate) return '-';
    const date = new Date(props.endDate);
    if (isNaN(date.getTime())) return '-';
    return `${date.getDate()} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`;
});

const clampedPercent = computed(() => {
    if (!props.progress) return 0;
    return Math.max(2, Math.min(100, props.progress.percent || 0));
});

return (_ctx: any,_cache: any) => {
  return (_ctx.member)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.member.photo_url || '/public/assets/users/300w/user2.jpg',
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.member.reference || `#${_ctx.member.id}`), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.member.nom) + " " + _toDisplayString(_ctx.member.prenom), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Collectivité", -1)),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.member.collectivite?.nom || 'N/A'), 1),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.member.email_verified_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "En cours"))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "Vérifié")),
            (_ctx.member.actif)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Actif"))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "Inactif"))
          ])
        ]),
        (_ctx.endDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Date de fin de souscription", -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(endDateFormatted.value), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.progress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.progress.label), 1),
                _createElementVNode("div", {
                  class: "progress-bar-fill bg-pop-green",
                  style: _normalizeStyle(`width: ${clampedPercent.value}%;`)
                }, _toDisplayString(_ctx.progress.valueLabel || `${Math.round(_ctx.progress.percent)}%`), 5)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})